import type { AcademicSession } from './types'

export interface ScanClaim {
  ticket: string
  sessionId: string
  deviceId: string
  issuedAt: number
  expiresAt: number
}
export const CLAIM_TTL_MS = 120_000
export const CLAIM_CLOSE_GRACE_MS = 30_000

export function registrationError(reason: unknown): string {
  const message = reason instanceof Error ? reason.message : String(reason || '')
  const labels: Record<string, string> = {
    QR_EXPIRED: 'El QR ya había expirado al abrirlo. Escanea el código actual de la pantalla.',
    CLAIM_EXPIRED: 'Terminó el tiempo para identificarte. Escanea de nuevo si la sesión sigue abierta.',
    CLAIM_GRACE_EXPIRED: 'Terminó la gracia de registro después del cierre. Consulta al profesor.',
    SESSION_CLOSED: 'La sesión está cerrada o finalizada. Consulta al profesor.',
    CLAIM_DEVICE_MISMATCH: 'Este permiso de registro pertenece a otro dispositivo.',
    CLAIM_SESSION_MISMATCH: 'Este permiso de registro pertenece a otra sesión.',
    CLAIM_USED: 'Este permiso ya se utilizó para otro alumno.',
    CLAIM_INVALID: 'El permiso de registro no es válido. Vuelve a escanear.',
    DEVICE_SESSION_CONFLICT: 'Este dispositivo ya registró a otro alumno en esta sesión. Consulta al profesor.',
  }
  return labels[message] || message || 'No se pudo registrar la asistencia.'
}

// Mock equivalent of Apps Script validation; Google authorization stays server-side.
export function validateMockClaim(claim: ScanClaim, session: AcademicSession | undefined, sessionId: string, deviceId: string, now = Date.now()) {
  if (claim.deviceId !== deviceId) throw new Error('CLAIM_DEVICE_MISMATCH')
  if (claim.sessionId !== sessionId) throw new Error('CLAIM_SESSION_MISMATCH')
  if (claim.expiresAt <= now) throw new Error('CLAIM_EXPIRED')
  if (!session || !['ACTIVE', 'REVIEW'].includes(session.status)) throw new Error('SESSION_CLOSED')
  if (!(claim.issuedAt <= (session.closesAt ?? 0)) || now >= (session.closesAt ?? 0) + CLAIM_CLOSE_GRACE_MS) throw new Error('CLAIM_GRACE_EXPIRED')
  return session
}
